import React from "react"
import BaseCard from "./BaseCard"

export default function ({ data }) {
  return <BaseCard data={data} isReversed hasAuthorImage />
}
